module.exports = __webpack_public_path__ + "static/media/sreya_sudheeran.ad85662b.png";